import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-magazine-lib',
  template: `
    <p>
      magazine-lib works!
    </p>
  `,
  styles: []
})
export class MagazineLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
